import * as React from "react";
import { DefaultButton } from "office-ui-fabric-react";
import { Depths } from "@fluentui/theme";
import { useState } from "react";
import { nanoid } from "nanoid";

export default function App() {
  const [id, setId] = useState(nanoid());

  return (
    <div
      style={{
        boxShadow: Depths.depth8,
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        rowGap: "0.4rem",
      }}
    >
      <div>{id}</div>
      <DefaultButton onClick={() => setId(nanoid())}>
        {"Generate"}
      </DefaultButton>
    </div>
  );
}
